"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.rgcpHtmlAddApi = rgcpHtmlAddApi;
exports.rgcpHtmlBulkHardDeleteApi = rgcpHtmlBulkHardDeleteApi;
exports.rgcpHtmlBulkRestoreApi = rgcpHtmlBulkRestoreApi;
exports.rgcpHtmlBulkSoftDeleteApi = rgcpHtmlBulkSoftDeleteApi;
exports.rgcpHtmlDefaultHtmlListApi = rgcpHtmlDefaultHtmlListApi;
exports.rgcpHtmlDeleteApi = rgcpHtmlDeleteApi;
exports.rgcpHtmlFetchApi = rgcpHtmlFetchApi;
exports.rgcpHtmlListApi = rgcpHtmlListApi;
exports.rgcpHtmlPreviewListApi = rgcpHtmlPreviewListApi;
exports.rgcpHtmlSoftDeleteApi = rgcpHtmlSoftDeleteApi;
exports.rgcpHtmlSoftDeleteRestoreApi = rgcpHtmlSoftDeleteRestoreApi;
exports.rgcpHtmlSoftDeletedListApi = rgcpHtmlSoftDeletedListApi;
exports.rgcpHtmlTypesApi = rgcpHtmlTypesApi;
exports.rgcpHtmlUpdateApi = rgcpHtmlUpdateApi;
exports.rgcpPanelPreviewListApi = rgcpPanelPreviewListApi;
exports.rgcpPerformancePreviewListApi = rgcpPerformancePreviewListApi;
var _core = require("../../../core/core.service");
var _app = _interopRequireDefault(require("../../../../configs/app.config"));
var _dashboard = require("../../../../constants/endpoints/dashboard");
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
// @flow

var api = new _core.APICore();

/**
 * list
 * @param payload
 * @returns api response
 * @description this function used to get list of data.
 */
function rgcpHtmlListApi(params) {
  return api.get("".concat(_app.default.baseUrl + _dashboard.ContentPanelService.rgcpHtml.list), params);
}

/**
 * list
 * @param payload
 * @returns api response
 * @description this function used to get list of data.
 */
function rgcpHtmlDefaultHtmlListApi(params) {
  return api.get("".concat(_app.default.baseUrl + _dashboard.ContentPanelService.rgcpHtml.defaultHtmlList), params);
}

/**
 * fetch
 * @param payload
 * @returns api response
 * @description this function used to get data.
 */
function rgcpHtmlFetchApi(params) {
  return api.get("".concat(_app.default.baseUrl + _dashboard.ContentPanelService.rgcpHtml.fetch), params);
}

/**
 * add
 * @param payload
 * @returns api response
 * @description this function used to add data.
 */
function rgcpHtmlAddApi(params) {
  return api.create("".concat(_app.default.baseUrl + _dashboard.ContentPanelService.rgcpHtml.add), params);
}

/**
 * update
 * @param payload
 * @returns api response
 * @description this function used to update data.
 */
function rgcpHtmlUpdateApi(params) {
  return api.update("".concat(_app.default.baseUrl + _dashboard.ContentPanelService.rgcpHtml.update), params);
}

/**
 * delete
 * @param payload
 * @returns api response
 * @description this function used to dalete data.
 */
function rgcpHtmlDeleteApi(params) {
  return api.delete("".concat(_app.default.baseUrl + _dashboard.ContentPanelService.rgcpHtml.delete), params);
}

/**
 * types
 * @param payload
 * @returns api response
 * @description this function used to get rgcp type data.
 */
function rgcpHtmlTypesApi(params) {
  return api.get("".concat(_app.default.baseUrl + _dashboard.ContentPanelService.rgcpHtml.types), params);
}

/**
 * types
 * @param payload
 * @returns api response
 * @description this function used to get rgcp type data.
 */
function rgcpHtmlPreviewListApi(params) {
  return api.get("".concat(_app.default.baseUrl + _dashboard.ContentPanelService.rgcpHtml.previewList), params);
}

/**
 * types
 * @param payload
 * @returns api response
 * @description this function used to get rgcp performance panel data.
 */
function rgcpPanelPreviewListApi(params) {
  return api.get("".concat(_app.default.baseUrl + _dashboard.ContentPanelService.rgcpHtml.panelPreviewList), params);
}

/**
 * types
 * @param payload
 * @returns api response
 * @description this function used to get rgcp panel data.
 */
function rgcpPerformancePreviewListApi(params) {
  return api.get("".concat(_app.default.baseUrl + _dashboard.ContentPanelService.rgcpHtml.performancePreview), params);
}

/**
 * soft delete
 * @param payload
 * @returns api response
 * @description this function used to soft dalete data.
 */
function rgcpHtmlSoftDeleteApi(params) {
  return api.delete("".concat(_app.default.baseUrl + _dashboard.ContentPanelService.rgcpHtml.softDelete), params);
}

/**
 * soft delete restore
 * @param payload
 * @returns api response
 * @description this function used to soft dalete restore data.
 */
function rgcpHtmlSoftDeleteRestoreApi(params) {
  return api.update("".concat(_app.default.baseUrl + _dashboard.ContentPanelService.rgcpHtml.softDeleteRestore), params);
}

/**
 * soft deleted list
 * @param payload
 * @returns api response
 * @description this function used to soft daleted list data.
 */
function rgcpHtmlSoftDeletedListApi(params) {
  return api.get("".concat(_app.default.baseUrl + _dashboard.ContentPanelService.rgcpHtml.softDeletedList), params);
}

/**
 * bulk soft delete
 * @param payload
 * @returns api response
 * @description this function used to bulk soft dalete data.
 */
function rgcpHtmlBulkSoftDeleteApi(params) {
  return api.update("".concat(_app.default.baseUrl + _dashboard.ContentPanelService.rgcpHtml.bulkSoftDelete), params);
}

/**
 * bulk hard delete
 * @param payload
 * @returns api response
 * @description this function used to bulk hard dalete data.
 */
function rgcpHtmlBulkHardDeleteApi(params) {
  return api.update("".concat(_app.default.baseUrl + _dashboard.ContentPanelService.rgcpHtml.bulkHardDelete), params);
}

/**
 * bulk restore
 * @param payload
 * @returns api response
 * @description this function used to bulk restore data.
 */
function rgcpHtmlBulkRestoreApi(params) {
  return api.update("".concat(_app.default.baseUrl + _dashboard.ContentPanelService.rgcpHtml.bulkRestore), params);
}